var _g, _path, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIgLite(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 70,
    height: 71,
    viewBox: "0 0 70 71",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_1:133)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 35,
    cy: 22.3805,
    r: 16.7999,
    fill: "#F53838"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M40.25 22.3806C40.25 23.773 39.6968 25.1083 38.7123 26.0929C37.7277 27.0774 36.3923 27.6306 35 27.6306C33.6076 27.6306 32.2722 27.0774 31.2876 26.0929C30.3031 25.1083 29.75 23.773 29.75 22.3806C29.75 22.0813 29.7815 21.7891 29.8357 21.5056H28V28.5003C28 28.9868 28.3937 29.3806 28.8802 29.3806H41.1215C41.3546 29.3801 41.5781 29.2872 41.7428 29.1221C41.9075 28.9571 42 28.7335 42 28.5003V21.5056H40.1642C40.2185 21.7891 40.25 22.0813 40.25 22.3806ZM35 25.8806C35.4597 25.8805 35.9149 25.7898 36.3396 25.6137C36.7643 25.4377 37.1502 25.1797 37.4752 24.8546C37.8002 24.5294 38.058 24.1434 38.2338 23.7186C38.4096 23.2938 38.5001 22.8386 38.5 22.3788C38.4998 21.9191 38.4092 21.4639 38.2331 21.0392C38.0571 20.6145 37.7991 20.2286 37.474 19.9036C37.1488 19.5786 36.7628 19.3208 36.338 19.145C35.9132 18.9691 35.4579 18.8787 34.9982 18.8788C34.0697 18.8791 33.1793 19.2481 32.523 19.9048C31.8666 20.5615 31.498 21.4521 31.4982 22.3806C31.4984 23.3091 31.8675 24.1994 32.5242 24.8558C33.1809 25.5122 34.0715 25.8808 35 25.8806ZM39.2 18.7056H41.2982C41.4376 18.7056 41.5713 18.6503 41.6701 18.5519C41.7688 18.4535 41.8245 18.32 41.825 18.1806V16.0823C41.825 15.9426 41.7695 15.8086 41.6707 15.7098C41.5719 15.6111 41.4379 15.5556 41.2982 15.5556H39.2C39.0603 15.5556 38.9263 15.6111 38.8275 15.7098C38.7287 15.8086 38.6732 15.9426 38.6732 16.0823V18.1806C38.675 18.4693 38.9112 18.7056 39.2 18.7056ZM35 5.58057C30.5443 5.58057 26.2712 7.35056 23.1206 10.5012C19.9699 13.6518 18.2 17.9249 18.2 22.3806C18.2 26.8362 19.9699 31.1094 23.1206 34.26C26.2712 37.4106 30.5443 39.1806 35 39.1806C37.2062 39.1806 39.3908 38.746 41.429 37.9017C43.4673 37.0575 45.3193 35.82 46.8794 34.26C48.4394 32.6999 49.6769 30.8479 50.5211 28.8097C51.3654 26.7714 51.8 24.5868 51.8 22.3806C51.8 20.1744 51.3654 17.9898 50.5211 15.9515C49.6769 13.9132 48.4394 12.0612 46.8794 10.5012C45.3193 8.94115 43.4673 7.70367 41.429 6.85939C39.3908 6.01511 37.2062 5.58057 35 5.58057ZM43.75 29.1863C43.75 30.2556 42.875 31.1306 41.8057 31.1306H28.1942C27.125 31.1306 26.25 30.2556 26.25 29.1863V15.5748C26.25 14.5056 27.125 13.6306 28.1942 13.6306H41.8057C42.875 13.6306 43.75 14.5056 43.75 15.5748V29.1863Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_1:133",
    x: 0.200073,
    y: 0.580566,
    width: 69.5999,
    height: 69.5999,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 13
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 9
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.0658854 0 0 0 0 0.0730469 0 0 0 0 0.1375 0 0 0 0.08 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1:133"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1:133",
    result: "shape"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIgLite);
export default __webpack_public_path__ + "static/media/ig-lite.630a07e9.svg";
export { ForwardRef as ReactComponent };